import { api } from './client';

/**
 * A2 · Filtros guardados. Prefijo: `/api/filtros-guardados`.
 *
 * La pantalla se identifica por su RUTA (`/jobs`, `/clientes`…), no por un
 * nombre. Con un nombre habría dos vocabularios para lo mismo; con la ruta, la
 * pantalla manda su `location.pathname` y no hay nada que traducir. El server
 * valida contra la misma lista, y un test lee este proyecto del disco para que
 * las dos no se separen.
 *
 * ⚠️ Lo que viaja en `consulta` es el `?query` con los TOKENS relativos adentro
 * (`rango=semana`), no las fechas resueltas. Es lo que hace que un filtro
 * llamado "Esta semana" siga significando esta semana el mes que viene.
 */

export interface FiltroGuardado {
  id: string;
  pantalla: string;
  nombre: string;
  consulta: string;
  creadoPorId: string;
  creadoPorNombre: string;
  /** ¿Lo creé yo? Decide si veo los botones de renombrar y borrar. */
  esMio: boolean;
  /** ¿Lo fijé YO como acceso rápido? Nunca es el favorito de otro. */
  esFavorito: boolean;
  createdAt: string;
}

export const listar = (pantalla: string) =>
  api.get<{ filtros: FiltroGuardado[]; pantallas: string[] }>(
    `/api/filtros-guardados?pantalla=${encodeURIComponent(pantalla)}`,
  );

export const crear = (pantalla: string, nombre: string, consulta: string) =>
  api.post<{ id: string; nombre: string }>('/api/filtros-guardados', {
    pantalla,
    nombre,
    consulta,
  });

export const renombrar = (id: string, nombre: string) =>
  api.patch<{ id: string; nombre: string }>(`/api/filtros-guardados/${id}`, { nombre });

/** Pisa la consulta guardada con los filtros que hay puestos ahora. */
export const actualizarConsulta = (id: string, consulta: string) =>
  api.put<{ id: string; consulta: string }>(`/api/filtros-guardados/${id}/consulta`, { consulta });

export const borrar = (id: string) => api.del<{ ok: true }>(`/api/filtros-guardados/${id}`);

export const alternarFavorito = (id: string) =>
  api.post<{ esFavorito: boolean }>(`/api/filtros-guardados/${id}/favorito`, {});
